import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { ActivationLockList } from './ActivationLockList';

export default withStyles(styles)(ActivationLockList);
